import React from 'react'

const Funfact = () => {
    return (
        <div className="content fuct">


            <div className="title">Fun Fact</div>


            <div className="row fuct-items">


                <div className="col col-d-3 col-t-3 col-m-6 border-line-v">
                    <div className="fuct-item">
                        <div className="icon"><span className="ion ion-music-note"></span></div>
                        <div className="name">Uncountable Tracks Listened</div>
                    </div>
                </div>


                <div className="col col-d-3 col-t-3 col-m-6 border-line-v">
                    <div className="fuct-item">
                        <div className="icon"><span className="ion ion-trophy"></span></div>
                        <div className="name">4 Awards Won</div>
                    </div>
                </div>


                <div className="col col-d-3 col-t-3 col-m-6 border-line-v">
                    <div className="fuct-item">
                        <div className="icon"><span className="ion ion-coffee"></span></div>
                        <div className="name">1000 Cups of coffee</div>
                    </div>
                </div>


                <div className="col col-d-3 col-t-3 col-m-6 border-line-v">
                    <div className="fuct-item">
                        <div className="icon"><span className="ion ion-bug"></span></div>
                        <div className="name">Countless Bugs Solved</div>
                    </div>
                </div>

                <div className="clear"></div>
            </div>

        </div>
    );
}

export default Funfact;